<!-- Navigation -->
<fuse-vertical-navigation
  class="bg-gray-900 dark print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall && !hideNavigation">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex items-center w-full p-4 pl-6" >
      <!-- Logo -->
      <div class="flex items-center justify-center">
        <img class="w-8" src="assets/images/logo/logo.png" />
      </div>
      <!-- Components -->
      <div class="flex items-center ml-auto">
        <!-- <notifications [notifications]="data.notifications"></notifications> -->
        <add-menu></add-menu>
        <user-menu [showAvatar]="false"></user-menu>
      </div>
    </div>
    <!-- User -->
    <div class="flex flex-col items-center w-full p-4">
      <div class="relative w-24 h-24">
        <ng-container *ngIf="!isInsolvTheme; else insolvLogoAvatar">
          <img class="w-full h-full rounded-full" *ngIf="user.avatar" [src]="user.avatar" alt="User avatar" />
          <mat-icon class="icon-size-24" *ngIf="!user.avatar" [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
        </ng-container>
        <ng-template #insolvLogoAvatar>
          <img class="w-full h-full object-contain" src="assets/images/logo/aryza-timekeeping-icon.png" alt="Aryza Timekeeping icon" />
        </ng-template>
      </div>
      <div class="flex flex-col items-center justify-center w-full mt-6">
        <div class="w-full overflow-hidden font-medium leading-normal text-center whitespace-nowrap text-ellipsis">
          {{ user.practiceName }}
        </div>
        <div class="w-full overflow-hidden font-medium leading-normal text-center whitespace-nowrap text-ellipsis">
          {{ user.name }}
        </div>
        <div
          class="
            w-full
            mt-0.5
            whitespace-nowrap
            text-ellipsis overflow-hidden
            text-center text-md
            leading-normal
            font-medium
            text-secondary
          ">
          {{ user.email }}
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationContentFooter>
    <div class="flex items-center justify-center h-16 pl-2 pr-6 mt-2 mb-4 flex-0 opacity-12">
      <img class="max-w-36" src="assets/images/logo/logo-text-on-dark.png" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div *ngIf="!hideNavigation"
    class="relative flex items-center w-full h-16 px-4 shadow flex-0 md:px-6 z-49 dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>
    <div class="pl-2 text-base font-normal tracking-tight md:text-xl sm:text-lg lg:text-2xl">
      <!-- show pageTitle on phone, practiceName on pc -->
      <span class="inline sm:hidden">{{ pageTitle }}</span>
      <span class="hidden sm:inline">{{ practiceName }}</span>
    </div>

    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-2">
      <!-- <language></language> -->
      <!-- <fuse-fullscreen></fuse-fullscreen> -->
      <help></help>
      <settings></settings>
      <search-bar></search-bar>
      <!-- <shortcuts [shortcuts]="data.shortcuts"></shortcuts> -->
      <messages></messages>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->
  <!--<div class="relative flex items-center justify-start w-full px-4 border-t flex-0 h-14 md:px-6 z-49 bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>
